class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends HTMLElement {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.details = this.querySelector('details');
    this.content = this.details.querySelector('summary').nextElementSibling;

    // Add event listeners for mouseenter and mouseleave
   this.details.addEventListener('mouseenter', this.onMouseEnter.bind(this));
   this.details.addEventListener('mouseleave', this.onMouseLeave.bind(this));
   this.content.addEventListener('mouseenter', this.onMouseEnter.bind(this));
   this.content.addEventListener('mouseleave', this.onMouseLeave.bind(this));
  }

  onMouseEnter() {
    clearTimeout(this.leaveTimeout);
    this.enterTimeout = setTimeout(() => {
      this.details.setAttribute('open', '');
    }, 100); // Adjust the delay as needed
  }

  onMouseLeave() {
    clearTimeout(this.enterTimeout);
    this.leaveTimeout = setTimeout(() => {
      this.details.removeAttribute('open');
    }, 300); // Small delay to allow focus to move to a descendant if needed
  }
}

customElements.define('header-menu', HeaderMenu);
